

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../controlador';
    import seguimiento from './envio-seguimiento.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            seguimiento
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Cliente() { return this.Controlador.Pedido.Cliente; }
        public get Envio() { return this.Controlador.Pedido.Envio; }
        public AbrirSeguimiento: boolean = false;
    }

